import {Arc} from './components/arc';
import {Ring} from './components/ring';
import {Root} from './components/root';

export const LoadingCircle = Object.assign(Root, {
	Ring,
	Arc,
});
